import { Component, Vue, Prop, Inject, Watch } from 'vue-property-decorator';
import { ProductType } from '@/common/types/ecommerce/ProductType';
import CustomFieldEditor from '../../components/custom-field/CustomFieldEditor.vue';
import DonationInput from '../../components/inputs/donation/DonationInput.vue';
import regexPattern from '@/components/directives/regexPattern-directive';
import { Addon } from '@/common/types/event/DtoAddon';
import { CustomField } from '@/common/types/CustomField/CustomField';
import { DtoCurrentUser } from '@/common/types/user/DtoCurrentUser';
import QuantityInput from '@/components/inputs/quantity/QuantityInput.vue';
import triggerPopover from '../directives/triggerPopover-directive';
import StringHelpers from '@/common/services/StringHelpers';
import { DtoProduct } from '@/common/types/ecommerce/DtoProduct';

@Component({
    name: 'Addon',
    components: {
        CustomFieldEditor,
        DonationInput,
        QuantityInput
    },
    directives: {
        regexPattern,
        triggerPopover
    }
})

export default class AddonItem extends Vue {

    @Prop({ required: true })
    addon!: Addon;

    @Prop({ required: false, default: false })
    showCustomFields!: boolean;

    @Prop({ required: true, default: true })
    showProductPrice!: boolean;

    @Inject('user')
    currentUser!: DtoCurrentUser;

    ProductType: any = ProductType; // Allows reference to this enum in template

    @Watch("addon.productPrice", { immediate: true })
    updatePricePaid() {
        if (this.addon.product.productType != ProductType.Donation) {
            this.addon.quantity.price = this.addon.productPrice; // Stores the actual price paid by the user
        }
    }

    get showAddOnItem() {
        var product = this.addon.product;
        if (product.hasPurchaseWindow && product.isOnlyVisibleInPurchaseWindow && !product.isWithinPurchaseWindow) {
            return false;
        }
        return true;
    }

    
     // Donation add-ons force quantity = 1 on mount, so use price > 0 to decide if custom fields apply. Other product types keep using quantity.
    get shouldShowAddonCustomFieldEditors(): boolean {
        if (this.addon.product.productType === ProductType.Donation) {
            const price = this.addon.quantity.price;
            return price != null && Number(price) > 0;
        }
        return this.addon.quantity.quantity > 0;
    }

    // Only ProductCustomField.Required = true makes the field required on add-ons (not global RequiredFrontend).
    addonCustomFieldIsRequired(field: CustomField): boolean {
        return field.requiredForProduct === true;
    }

    /** Escape for data-html popovers (triggerPopover sets sanitize:false). */
    getRestrictionLockPopoverContent(product: DtoProduct): string {
        return StringHelpers.escapeHtml(product.restrictionMessage);
    }

    getRestrictionLockPopoverTitle(product: DtoProduct): string {
        return StringHelpers.escapeHtml(product.restrictionTitle);
    }

    mounted() {
        if (this.addon.product.productType == ProductType.Donation) {
            this.addon.quantity.quantity = 1;
        }
    }
}